export enum InstructorProfileStatus {
  PENDING = "pending",
  UNDER_REVIEW = "under_review",
  VERIFIED = "verified",
  REJECTED = "rejected",
  SUSPENDED = "suspended",
}
